import React from 'react';

interface AdjustPanelProps {
  volume: number;
  onVolumeChange: (v: number) => void;
  speed: number;
  onSpeedChange: (s: number) => void;
  brightness: number;
  onBrightnessChange: (b: number) => void;
  contrast: number;
  onContrastChange: (c: number) => void;
  saturation: number;
  onSaturationChange: (s: number) => void;
  onClose: () => void;
}

const AdjustPanel: React.FC<AdjustPanelProps> = ({
  volume, onVolumeChange,
  speed, onSpeedChange,
  brightness, onBrightnessChange,
  contrast, onContrastChange,
  saturation, onSaturationChange,
  onClose,
}) => {
  return (
    <div className="adjust-panel">
      <div className="adjust-panel-header">
        <h3>Adjust</h3>
        <button className="btn-icon" onClick={onClose}>✕</button>
      </div>
      <div className="adjust-panel-body">
        <div className="adjust-row">
          <label>Volume</label>
          <input type="range" min={0} max={200} value={volume} onChange={e => onVolumeChange(Number(e.target.value))} />
          <span className="adjust-val">{volume}%</span>
        </div>
        <div className="adjust-row">
          <label>Speed</label>
          <input type="range" min={25} max={400} step={25} value={speed * 100} onChange={e => onSpeedChange(Number(e.target.value) / 100)} />
          <span className="adjust-val">{speed}x</span>
        </div>
        <div className="adjust-row">
          <label>Brightness</label>
          <input type="range" min={-100} max={100} value={brightness} onChange={e => onBrightnessChange(Number(e.target.value))} />
          <span className="adjust-val">{brightness}</span>
        </div>
        <div className="adjust-row">
          <label>Contrast</label>
          <input type="range" min={-100} max={100} value={contrast} onChange={e => onContrastChange(Number(e.target.value))} />
          <span className="adjust-val">{contrast}</span>
        </div>
        <div className="adjust-row">
          <label>Saturation</label>
          <input type="range" min={-100} max={100} value={saturation} onChange={e => onSaturationChange(Number(e.target.value))} />
          <span className="adjust-val">{saturation}</span>
        </div>
      </div>
    </div>
  );
};

export default AdjustPanel;
